// Security Reducer

import {
  GET_SECURITY_AUTH_ROLE_LIST,
  GET_SECURITY_AUTH_ROLE_LIST_SUCCESS,
  GET_SECURITY_AUTH_ROLE_LIST_FAILURE,
  GET_SECURITY_AUTH_ROLE_BY_ID,
  GET_SECURITY_AUTH_ROLE_BY_ID_SUCCESS,
  GET_SECURITY_AUTH_ROLE_BY_ID_FAILURE,
  CREATE_SECURITY_AUTH_ROLE,
  CREATE_SECURITY_AUTH_ROLE_SUCCESS,
  CREATE_SECURITY_AUTH_ROLE_FAILURE,
  UPDATE_SECURITY_AUTH_ROLE,
  UPDATE_SECURITY_AUTH_ROLE_SUCCESS,
  UPDATE_SECURITY_AUTH_ROLE_FAILURE,
  DELETE_SECURITY_AUTH_ROLE,
  DELETE_SECURITY_AUTH_ROLE_SUCCESS,
  DELETE_SECURITY_AUTH_ROLE_FAILURE,
  GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST,
  GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_SUCCESS,
  GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_FAILURE,
  GET_SECURITY_AUTH_ROLE_TO_USER_LIST,
  GET_SECURITY_AUTH_ROLE_TO_USER_LIST_SUCCESS,
  GET_SECURITY_AUTH_ROLE_TO_USER_LIST_FAILURE,
  CREATE_SECURITY_AUTH_ROLE_TO_USER,
  CREATE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS,
  CREATE_SECURITY_AUTH_ROLE_TO_USER_FAILURE,
  UPDATE_SECURITY_AUTH_ROLE_TO_USER,
  UPDATE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS,
  UPDATE_SECURITY_AUTH_ROLE_TO_USER_FAILURE,
  DELETE_SECURITY_AUTH_ROLE_TO_USER,
  DELETE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS,
  DELETE_SECURITY_AUTH_ROLE_TO_USER_FAILURE,
  CREATE_SECURITY_AUTH_MISSING_REQUEST,
  CREATE_SECURITY_AUTH_MISSING_REQUEST_SUCCESS,
  CREATE_SECURITY_AUTH_MISSING_REQUEST_FAILURE,
} from "./actionType";

const initialState = {
  securityAuthRoleList: [],
  securityAuthRoleListLoading: false,
  securityAuthRoleListError: "",
  securityAuthRoleById: [],
  securityAuthRoleByIdLoading: false,
  securityAuthRoleByIdError: "",
  securityAuthRoleCreateSuccess: [],
  securityAuthRoleCreateLoading: false,
  securityAuthRoleCreateError: "",
  securityAuthRoleUpdateSuccess: [],
  securityAuthRoleUpdateLoading: false,
  securityAuthRoleUpdateError: "",
  securityAuthRoleDeleteSuccess: [],
  securityAuthRoleDeleteLoading: false,
  securityAuthRoleDeleteError: "",
  masterSecurityAuthCapabilityList: [],
  masterSecurityAuthCapabilityListLoading: false,
  masterSecurityAuthCapabilityListError: "",
  securityAuthRoleToUserList: [],
  securityAuthRoleToUserListLoading: false,
  securityAuthRoleToUserListError: "",
  securityAuthRoleToUserCreateSuccess: [],
  securityAuthRoleToUserCreateLoading: false,
  securityAuthRoleToUserCreateError: "",
  securityAuthRoleToUserUpdateSuccess: [],
  securityAuthRoleToUserUpdateLoading: false,
  securityAuthRoleToUserUpdateError: "",
  securityAuthRoleToUserDeleteSuccess: [],
  securityAuthRoleToUserDeleteLoading: false,
  securityAuthRoleToUserDeleteError: "",
  securityAuthMissingRequestCreateSuccess: [],
  securityAuthMissingRequestCreateLoading: false,
  securityAuthMissingRequestCreateError: "",
};

const Security = (state = initialState, action) => {
  switch (action.type) {
    case GET_SECURITY_AUTH_ROLE_LIST:
      return {
        ...state,
        securityAuthRoleListLoading: true,
      };
    case GET_SECURITY_AUTH_ROLE_LIST_SUCCESS:
      return {
        ...state,
        securityAuthRoleListLoading: false,
        securityAuthRoleList: action.payload,
      };
    case GET_SECURITY_AUTH_ROLE_LIST_FAILURE:
      return {
        ...state,
        securityAuthRoleListLoading: false,
        securityAuthRoleListError: action.payload,
      };
    case GET_SECURITY_AUTH_ROLE_BY_ID:
      return { ...state, securityAuthRoleByIdLoading: true };
    case GET_SECURITY_AUTH_ROLE_BY_ID_SUCCESS:
      return {
        ...state,
        securityAuthRoleByIdLoading: false,
        securityAuthRoleById: action.payload,
      };
    case GET_SECURITY_AUTH_ROLE_BY_ID_FAILURE:
      return {
        ...state,
        securityAuthRoleByIdLoading: false,
        securityAuthRoleByIdError: action.payload,
      };
    case CREATE_SECURITY_AUTH_ROLE:
      return { ...state, securityAuthRoleCreateLoading: true };
    case CREATE_SECURITY_AUTH_ROLE_SUCCESS:
      return {
        ...state,
        securityAuthRoleCreateLoading: false,
        securityAuthRoleCreateSuccess: action.payload,
      };
    case CREATE_SECURITY_AUTH_ROLE_FAILURE:
      return {
        ...state,
        securityAuthRoleCreateLoading: false,
        securityAuthRoleCreateError: action.payload,
      };
    case UPDATE_SECURITY_AUTH_ROLE:
      return { ...state, securityAuthRoleUpdateLoading: true };
    case UPDATE_SECURITY_AUTH_ROLE_SUCCESS:
      return {
        ...state,
        securityAuthRoleUpdateLoading: false,
        securityAuthRoleUpdateSuccess: action.payload,
      };
    case UPDATE_SECURITY_AUTH_ROLE_FAILURE:
      return {
        ...state,
        securityAuthRoleUpdateLoading: false,
        securityAuthRoleUpdateError: action.payload,
      };
    case DELETE_SECURITY_AUTH_ROLE:
      return { ...state, securityAuthRoleDeleteLoading: true };
    case DELETE_SECURITY_AUTH_ROLE_SUCCESS:
      return {
        ...state,
        securityAuthRoleDeleteLoading: false,
        securityAuthRoleDeleteSuccess: action.payload,
      };
    case DELETE_SECURITY_AUTH_ROLE_FAILURE:
      return {
        ...state,
        securityAuthRoleDeleteLoading: false,
        securityAuthRoleDeleteError: action.payload,
      };
    case GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST:
      return { ...state, masterSecurityAuthCapabilityListLoading: true };
    case GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_SUCCESS:
      return {
        ...state,
        masterSecurityAuthCapabilityListLoading: false,
        masterSecurityAuthCapabilityList: action.payload,
      };
    case GET_MASTER_SECURITY_AUTH_CAPABILITY_LIST_FAILURE:
      return {
        ...state,
        masterSecurityAuthCapabilityListLoading: false,
        masterSecurityAuthCapabilityListError: action.payload,
      };
    case GET_SECURITY_AUTH_ROLE_TO_USER_LIST:
      return { ...state, securityAuthRoleToUserListLoading: true };
    case GET_SECURITY_AUTH_ROLE_TO_USER_LIST_SUCCESS:
      return {
        ...state,
        securityAuthRoleToUserListLoading: false,
        securityAuthRoleToUserList: action.payload,
      };
    case GET_SECURITY_AUTH_ROLE_TO_USER_LIST_FAILURE:
      return {
        ...state,
        securityAuthRoleToUserListLoading: false,
        securityAuthRoleToUserListError: action.payload,
      };
    case CREATE_SECURITY_AUTH_ROLE_TO_USER:
      return { ...state, securityAuthRoleToUserCreateLoading: true };
    case CREATE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS:
      return {
        ...state,
        securityAuthRoleToUserCreateLoading: false,
        securityAuthRoleToUserCreateSuccess: action.payload,
      };
    case CREATE_SECURITY_AUTH_ROLE_TO_USER_FAILURE:
      return {
        ...state,
        securityAuthRoleToUserCreateLoading: false,
        securityAuthRoleToUserCreateError: action.payload,
      };
    case UPDATE_SECURITY_AUTH_ROLE_TO_USER:
      return { ...state, securityAuthRoleToUserUpdateLoading: true };
    case UPDATE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS:
      return {
        ...state,
        securityAuthRoleToUserUpdateLoading: false,
        securityAuthRoleToUserUpdateSuccess: action.payload,
      };
    case UPDATE_SECURITY_AUTH_ROLE_TO_USER_FAILURE:
      return {
        ...state,
        securityAuthRoleToUserUpdateLoading: false,
        securityAuthRoleToUserUpdateError: action.payload,
      };
    case DELETE_SECURITY_AUTH_ROLE_TO_USER:
      return { ...state, securityAuthRoleToUserDeleteLoading: true };
    case DELETE_SECURITY_AUTH_ROLE_TO_USER_SUCCESS:
      return {
        ...state,
        securityAuthRoleToUserDeleteLoading: false,
        securityAuthRoleToUserDeleteSuccess: action.payload,
      };
    case DELETE_SECURITY_AUTH_ROLE_TO_USER_FAILURE:
      return {
        ...state,
        securityAuthRoleToUserDeleteLoading: false,
        securityAuthRoleToUserDeleteError: action.payload,
      };
    case CREATE_SECURITY_AUTH_MISSING_REQUEST:
      return { ...state, securityAuthMissingRequestCreateLoading: true };
    case CREATE_SECURITY_AUTH_MISSING_REQUEST_SUCCESS:
      return {
        ...state,
        securityAuthMissingRequestCreateLoading: false,
        securityAuthMissingRequestCreateSuccess: action.payload,
      };
    case CREATE_SECURITY_AUTH_MISSING_REQUEST_FAILURE:
      return {
        ...state,
        securityAuthMissingRequestCreateLoading: false,
        securityAuthMissingRequestCreateError: action.payload,
      };

    default:
      return state;
  }
};

export default Security;
